"use client";
import React, { useState } from "react";
import dynamic from "next/dynamic";
import { useProductDetailsContext } from "@/src/provider";
const SpecificationsDrawer = dynamic(() => import("./SpecificationsDrawer"));
import DiffrentInfo from "./DiffrentInfo";
interface IProps {}
const ProductDetailSpecificationsClient: React.FC<
    React.PropsWithChildren<IProps>
> = (props) => {
    const [productDetail] = useProductDetailsContext((state) => [
        state.productDetail,
    ]);

    const [visible, setVisible] = useState(false);

    const opendio = () => {
        setVisible(true);
    };
    const handleCancel = () => {
        setVisible(false);
    };

    const { origin_products_metal } = productDetail;

    let isShowCustomers = false;
    if (origin_products_metal) {
        let origin_products_metal_arr = origin_products_metal.split(",");
        if (origin_products_metal_arr.includes("m")) {
            isShowCustomers = true;
        }
    }

    return (
        <>
            {props.children}
            {/* diffrent */}
            <DiffrentInfo productDetail={productDetail} opendio={opendio} />

            <SpecificationsDrawer visible={visible} onClose={handleCancel} />
        </>
    );
};

export default ProductDetailSpecificationsClient;
